import classNames from "classnames";
import { getVocabulary } from "components/Vocabulary";
import { RiskRatingColors } from "constants/Layout";
import React from "react";
import { RiskRatings } from "utils/riskScoreUtil";

import "./ACRiskRatingTag.less";

export type RiskRating = keyof typeof RiskRatings;

interface RiskRatingTagProps {
  rating: RiskRating;
  className?: string;
  style?: React.CSSProperties;
}

export default function ACRiskRatingTag({
  rating,
  className,
}: RiskRatingTagProps) {
  const prefixCls = "ac-risk-rating";
  const label = getVocabulary(rating);

  const tag = (
    <div
      className={classNames(
        `${prefixCls}-tag`,
        `${prefixCls}-${rating}`,
        className,
      )}
      title={label}
    >
      <span className={`${prefixCls}-content`}>{label}</span>
    </div>
  );

  return tag;
}

export function RiskRatingDot({
  rating,
  className,
  style,
}: RiskRatingTagProps) {
  return (
    <span
      className={className}
      style={{
        display: "inline-block",
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        backgroundColor: RiskRatingColors[rating],
        ...style,
      }}
    />
  );
}
